import { useQuery } from 'react-query';

import getQuote from '@/ebat/api/quotes/getQuote';

const useQuote = (queryKey) => useQuery(queryKey, getQuote);

export default useQuote;
